import { render, staticRenderFns } from "./RelatoriosPage.vue?vue&type=template&id=57568cf6&"
import script from "./RelatoriosPage.vue?vue&type=script&lang=js&"
export * from "./RelatoriosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports